import React from 'react';
import PropTypes from 'prop-types';
import SvgSymbol from 'common/components/svg-symbol';
import {t} from 'common/utils/translation-util';
import * as ModalType from 'storyboard/constants/modal-type';
import './index.scss';

export default class StoryboardLogo extends React.Component {
  static propTypes = {
    addLogoLabel: PropTypes.string,
    data: PropTypes.object.isRequired,
    deleteLogoLabel: PropTypes.string,
    isEditable: PropTypes.bool,
    openModal: PropTypes.func,
    superpartnerFooterLogo: PropTypes.string,
  };

  static defaultProps = {
    addLogoLabel: t('Add a logo'),
    deleteLogoLabel: t('Delete logo'),
    isEditable: false,
    openModal: () => {},
    superpartnerFooterLogo: '',
  };

  constructor() {
    super();
    this.handleAddLogoClick = this.handleAddLogoClick.bind(this);
    this.handleDeleteClick = this.handleDeleteClick.bind(this);
  }

  getBackgroundUrl(logo, superpartnerFooterLogo) {
    return superpartnerFooterLogo
      ? '/static/www/logo-atrius.svg'
      : logo.originalImage;
  }

  getLogoHeight(superpartnerFooterLogo) {
    // When a superpartner footer logo is present,
    // our branding should be a little smaller,
    // to give greater prominence
    // to the superpartner logo.
    return superpartnerFooterLogo ? '30%' : '60%';
  }

  getLogoStyle(backgroundUrl, logoHeight) {
    return {
      background: `url(${backgroundUrl})`,
      backgroundPosition: 'right 0px',
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'contain',
      height: logoHeight,
    };
  }

  canBeEdited(isEditable, superpartnerFooterLogo) {
    // The logo is never editable when a superpartner
    // footer logo is present.
    return superpartnerFooterLogo ? false : isEditable;
  }

  render() {
    const className = 'StoryboardLogo';
    const logo = this.props.data.logo || {};
    const {superpartnerFooterLogo} = this.props;
    const backgroundUrl = this.getBackgroundUrl(logo, superpartnerFooterLogo);
    const logoHeight = this.getLogoHeight(superpartnerFooterLogo);
    const logoStyle = this.getLogoStyle(backgroundUrl, logoHeight);
    const isEditable = this.canBeEdited(
      this.props.data.isEditable,
      superpartnerFooterLogo,
    );
    if (isEditable) {
      return backgroundUrl ? (
        <div
          className={`${className}--container`}
          onClick={this.handleDeleteClick}>
          <div className={className} style={logoStyle} />
          <SvgSymbol name={'delete'} />
        </div>
      ) : (
        <div
          className={`${className}--addButton`}
          onClick={this.handleAddLogoClick}>
          <SvgSymbol name={'add'} />
          <div className={`${className}--addButtonLabel`}>
            {t('Add a logo')}
          </div>
        </div>
      );
    }
    return backgroundUrl ? (
      <div className={className} style={logoStyle} />
    ) : null;
  }

  handleAddLogoClick(event) {
    event.preventDefault();
    this.props.openModal(ModalType.ADD_LOGO, this.props.addLogoLabel);
  }

  handleDeleteClick(event) {
    event.preventDefault();
    this.props.openModal(ModalType.DELETE_LOGO, this.props.deleteLogoLabel);
  }
}
